<template>
  <div class="hzc-industry-dynamics no-li">
    <div class="back">当前位置：<span style="cursor: pointer" @click="back('/cokeBenzene')">焦化苯</span> > <span
        @click="back('/cokeBenzene/twoPage/exit')" style="cursor: pointer">进出口</span> > 正文
    </div>
    <div class="content">
      <div class="top">
        <p>{{ row.titleName }}</p>
        <span>发布时间：{{ row.showYearTime }}</span><span>来源：{{ row.updateBy || "网络" }}</span>
      </div>
      <div class="bom" v-html="row.newsContent"></div>
      <div class="echarts">
        <div id="myChart" style="width: 800px;height:500px;"></div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  exitGuoDetail,
  exitDetailData
} from '@/api/cokeBenzene'

export default {
  data() {
    return {
      row: {},
      page: 1,
      size: 15,
      total: 0,
      title: '',
      flag: '19',
      id: '',
      option: {
        tooltip: {
          trigger: 'item'
        },
        legend: {
          top: 'bottom'
        },
        series: [
          {
            type: 'pie',
            radius: '50%',
            data: [
              {name: '韩国', value: 74280.964},
              {name: '泰国', value: 33064.608},
              {name: '文莱', value: 18139.448},
              {name: '印度', value: 12092.82},
              {name: '马来西亚', value: 9192.273},
              {name: '阿曼', value: 6276.308},
              {name: '新加坡', value: 6219.408},
              {name: '印度尼西亚', value: 6000.458},
              {name: '越南', value: 5910.562},
              {name: '日本', value: 3000.565}
            ],
            itemStyle: {
              normal: {
                label: {        //此处为指示线文字
                  show: true,
                  textStyle: {
                    fontWeight: 200,
                    fontSize: 16    //文字的字体大小
                  },
                  formatter: function (p) {   //指示线对应文字
                    var data = p.name + ':' + p.percent + '%';
                    return data;
                  }
                },
              }
            },
          }
        ],
      },
      optionOne: {
        title: {
          text: "石油苯进出口量  单位：万吨",
          x: 'center',
          y: 'top'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          x: 'center',      //可设定图例在左、右、居中
          y: 'bottom',
          data: []
        },
        xAxis: {
          data: ['1月', '2月', '3月', '4月', '5月', '6月'],
          axisLabel: {
            interval: 0,
            rotate: 40
          }
        },
        yAxis: {
          splitLine: {show: false},
        },
        series: [
          {
            name: '',
            emphasis: {
              focus: 'series'
            },
            type: "bar",
            data: [],
          },
          {
            name: '',
            emphasis: {
              focus: 'series'
            },
            type: "bar",
            data: [],
          },
        ],
        grid: {
          left: '3%',
          right: '4%',
          bottom: '8%',
          containLabel: true
        },
      }
    }
  },
  created() {
    if (this.$route.query.flag) {
      this.flag = this.$route.query.flag;
      this.id = this.$route.query.id;
    }
    if (this.flag === '19') {
      this.title = '按产销国统计'
      this.getGuo(this.$route.query.id);
    } else if (this.flag === '20') {
      this.title = '数据统计'
      this.getShu(this.$route.query.id);
    }
  },
  methods: {
    // 按产国销
    getGuo(pageParams) {
      exitGuoDetail(pageParams).then(res => {
        this.row = res.data;
        this.option.series[0].data = JSON.parse(res.data.contentOne);
        this.drawChart(this.option)
      })
    },
    // 数据
    getShu(pageParams) {
      exitGuoDetail(pageParams).then(res => {
        exitDetailData({dictDataType: 'issue_petroleum_benzene_exit_statistics'}).then(res => {
          this.optionOne.series[0]['data'] = res.data.importList;
          this.optionOne.series[1]['data'] = res.data.exportList;
          this.optionOne.series[0]['name'] = res.data.titleList[0];
          this.optionOne.series[1]['name'] = res.data.titleList[1];
          this.optionOne.legend.data.push(res.data.titleList[0]);
          this.optionOne.legend.data.push(res.data.titleList[1]);
          this.optionOne.xAxis.data = res.data.timeList;
          this.drawChart(this.optionOne)
        })
        this.row = res.data;
      })
    },
    /**
     * 加载地图
     */
    drawChart(option) {
      let myChart = this.$echarts.init(document.getElementById("myChart"));
      myChart.setOption(option);
    },
    back(url) {
      this.$router.push({path: url, query: {flag: this.flag}});
    },
  }
}
</script>

<style scoped lang="less">
.hzc-industry-dynamics {
  width: 1200px;
  margin: 0 auto;
  margin-bottom: 20px;

  .content {
    width: 960px;
    min-height: 500px;
    border-radius: 4px;
    border: 1px solid #CCCCCC;
    margin: 16px auto 0;
    padding-bottom: 20px;

    .top {

      border-bottom: 1px solid #ccc;
      padding: 16px 0;
      text-align: center;

      p {
        color: #222;
        font-size: 24px;
      }

      span {
        display: inline-block;
        margin-right: 16px;
        color: #777777;
        font-size: 12px;
      }
    }

    .bom {
      padding: 16px 40px;

      ::v-deep {
        img {
          max-width: 100%;
        }
      }
    }
  }
}

.echarts {
  margin-left: 100px;
}
</style>
